
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';

import * as XLSX from 'xlsx';
import { CheckProdutoInventarioImport as CheckContagemInventarioImport, InventarioProdutoImport as InventarioContagemImport, InventarioProdutoImport } from '../models/inventario';
import { ProdutoService } from 'src/app/sigeve/produto/produto.service';
import { InventarioService } from '../inventario.service';
import {v4 as uuidv4} from 'uuid';

type AOA = any[][];
@Component({
  selector: 'app-contagem-adicionar',
  templateUrl: './contagem-adicionar.component.html',
  styleUrls: ['./contagem-adicionar.component.scss']
})
export class ContagemAdicionarComponent implements OnInit {

  
  propostasFile: any;
  data: any;
  listaContagem: InventarioContagemImport[] = [];
  novaListaContagem: InventarioContagemImport[] = [];
  checkProduto: CheckContagemInventarioImport[] = [];
  produto: InventarioContagemImport;
  novoProduto: InventarioContagemImport;
  public podeImportar: boolean = false;
  public gridLoading: boolean = false;

  produtoFile: any[];
  displayDialog: boolean;
  propostaEditar: any = {};

  public idEtapa: any;
  public idInventario: any;
  public eventoDescricao: string;
  add: boolean;

  mensagensErroValidacao = {
    'produtoNulo': 'O campo produto não pode ser nulo',    
    'fornecedorNulo': 'O campo nome não pode ser nulo',    
    'qtdContagemZero': 'O campo quantidade de contagem deve ser maior que ZERO'
  };
  mostrarColunaDeErros: boolean = false;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private notificationsService: NotificationsService,
              private produtoService: ProdutoService,
              private inventarioService: InventarioService,) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if (params.has('idInventario')) {
        this.idInventario = params.get('idInventario');
      }
      if (params.has('idEtapa')) {
        this.idEtapa = params.get('idEtapa');
      }
    });
  }

  addContagem(){
 this.add=true;
      this.novoProduto = {} as InventarioContagemImport;

      this.novoProduto.guid=uuidv4();
      this.displayDialog = true;
   
  }

  editProduto(produto: InventarioContagemImport) {
    this.add=false;
    this.produto = produto;
    this.novoProduto = { ...produto };
    this.displayDialog = true;
  }

  // cloneProduto(produto: InventarioProdutoImport) {    
  //   for (let prop in produto) {
  //     this.novoProduto[prop] = produto[prop];    }
  //   return this.novoProduto;
  // }

  saveProduto() {
    console.log(this.listaContagem)
    this.novaListaContagem = [...this.listaContagem];
    if(this.add){
      this.novaListaContagem.push(this.novoProduto)
    }else{
      this.novaListaContagem[this.listaContagem.indexOf(this.produto)] = this.novoProduto;
    }
    this.propostaEditar = null;
    this.listaContagem = this.novaListaContagem;
    
    this.getCheckProduto();
    
    this.displayDialog = false;
  }

  deleteProduto(produto: InventarioContagemImport) {
    console.log(produto);
    console.log(this.listaContagem.indexOf(produto));
    this.listaContagem.splice(this.listaContagem.indexOf(produto),1);    
    this.displayDialog = false;
  }




  hideDialog() {
    this.displayDialog = false;
  }

  validarProdutoFornecedor()
  {
    this.gridLoading = true;
    this.getCheckProduto();
    this.gridLoading = false;
  }

  validarProdutos() {
    let mensagem = [];   
    if(this.listaContagem.length==0){
      this.notificationsService.toastNotify('error', 'Validação', 'Selecione o arquivo antes de validar.');
      return;
    }

    this.listaContagem.forEach(element => {
      if (!this.validaProduto(element.produto) && !mensagem.includes(this.mensagensErroValidacao.produtoNulo)) {
        mensagem.push(this.mensagensErroValidacao.produtoNulo);
      }

      if (!this.validaValor(element.qtdContagem) && !mensagem.includes(this.mensagensErroValidacao.qtdContagemZero)) {
        mensagem.push(this.mensagensErroValidacao.qtdContagemZero);
      }

    });

     if (mensagem.length > 0) {
       this.podeImportar = false;
       this.notificationsService.toastNotify('error', 'Erro', mensagem.toString());
       this.mostrarColunaDeErros = true;
     }
     else{
      this.notificationsService.toastNotify('success', 'Validação', 'Produtos validados com sucesso.');
       this.podeImportar = true;
     }


  }

  importarProdutos() {
    
    this.inventarioService
    .checkImportarContagens(this.idEtapa, this.listaContagem)
    .subscribe(
      () => {           
        this.notificationsService.toastNotify('success', 'Sucesso', 'Contagens importadas com sucesso!');
        this.listaContagem = [];  
        this.propostasFile = null;  
        this.podeImportar = false;
      },
      err => {
        console.log(err);        
      }
    );
  }   

  onFileChange(evt: any) {
    //console.log(evt.target);
    this.listaContagem = [];
    this.mostrarColunaDeErros = false;

    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      
      this.data.forEach(element => {

        if ((element[0] != "Produto") && (element[0] != null)) {

          let guid = uuidv4();
          let prod: string = element[0];

          try{
              prod =prod.replace(/\./g,'');
          }catch(ex){

          }

          console.log(prod);

          
          var reg = { produto: prod, nome: "", qtdContagem: element[1],existeProduto: false, guid:guid };
          if (reg != null) {                        
            this.listaContagem.push(reg);         
          }
        }
      });
    };
    console.log(this.listaContagem);
    reader.readAsBinaryString(target.files[0]);         
  }
  

  validaProduto(produto) {    
    if (produto){
      if (this.existeProduto(produto))
        return true;
      else{
        this.mensagensErroValidacao.produtoNulo = "O campo produto deve estar listado na etapa";
        return false;
      }

    }
    else {      
      return false;
    }
  }

 

  validaValor(valor) {
    if (valor && valor > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  validaSimNao(valor) {
    if (valor && (valor.toUpperCase() == "SIM" || valor.toUpperCase()  == "NAO")) {
      return true;
    }
    else {
      return false;
    }
  }

  baixarArquivo() {
    let link = document.createElement("a");
    link.download = "ModeloImportarContagem.xlsx";
    link.href = "./assets/template-importacao/ModeloImportarContagem.xlsx";
    link.click();
  }

 

  logClick() {
    this.router.navigate(['/evento-produto-importar-log'])

  }

  existeProduto(produto: string)
  {
    let existe = this.listaContagem.find(x => x.produto === produto);
    return existe.existeProduto;
  }



  getCheckProduto()
  {
    this.produtoService
    .checkProduto(this.listaContagem, this.idEtapa)
    .subscribe(
      (response) => {           
        this.listaContagem = response;
        console.log(this.listaContagem);
        this.validarProdutos()        
      },
      err => {
        console.log(err);        
      }
    );
  }


}
